import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RefillAlertsList } from "../../Apis/AuthApiServices";
import {
  loadingRefillAlertsList,
  setRefillAlertsList,
} from "../Slice/RefillAlertsListSlice";

function* onLoadRefillAlertsListAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("doctorId", payload.docId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  params.append("selecteduserid", payload.selecteduserid);
  try {
    const result: AxiosResponse = yield RefillAlertsList(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRefillAlertsList({
          RefillAlertsListData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRefillAlertsList({
          RefillAlertsListData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRefillAlertsList({
        RefillAlertsListData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRefillAlertsList() {
  yield takeLatest(loadingRefillAlertsList.type, onLoadRefillAlertsListAsync);
}

const RefillAlertsListSaga = [fork(onLoadRefillAlertsList)];
export default RefillAlertsListSaga;
